import { postToServer } from "@/client/utils/postToServer";
import { uploadFilesToS3 } from "@/client/utils/s3Upload";
import { createErrorMessage } from "@/shared/utils/error";
import {
    kSearchWithSoundSimilarEndpoint,
    type AssetCategorySlug,
    type SampleFamilySlug,
    type SearchWithSoundSimilarSuccessResponse,
} from "@/shared/search-with-sound-similar.api";

export interface SearchWithSoundSimilarParams {
    inputFile: File;
    maxResults?: number;
    maxDistance?: number;
    assetCategorySlug?: AssetCategorySlug;
    sampleFamilySlug?: SampleFamilySlug;
}

export const createSearchWithSoundSimilarService = () => {
    const search = async (
        params: SearchWithSoundSimilarParams,
    ): Promise<SearchWithSoundSimilarSuccessResponse | Error> => {
        try {
            const keysOrError = await uploadFilesToS3({ inputFileKey: params.inputFile });
            if (keysOrError instanceof Error) {
                return keysOrError;
            }

            const result = await postToServer(kSearchWithSoundSimilarEndpoint, {
                inputFileKey: keysOrError.inputFileKey,
                maxResults: params.maxResults,
                maxDistance: params.maxDistance,
                assetCategorySlug: params.assetCategorySlug,
                sampleFamilySlug: params.sampleFamilySlug,
            });

            if (result instanceof Error) {
                return result;
            }

            return result;
        } catch (error) {
            return new Error(createErrorMessage(error));
        }
    };

    return { search };
};

export type SearchWithSoundSimilarService = ReturnType<typeof createSearchWithSoundSimilarService>;
